import React from 'react';
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";
import UserAvatar from 'app/components/UserAvatar';
import StatusIndicator from '../../StatusIndicator';
import PaymentActionsDropdown from '../../Customers/CustomerDetails/PaymentActionsDropdown';
import dropdownStyles from '../../Customers/CustomerDetails/styles.module.scss';

interface AthleteListItemProps {
  athlete: any;
  onMarkAsPaid: (purchaseId: number) => void;
  onMarkAsUnpaid: (purchaseId: number) => void;
  markingPaidId: number | null;
}

export default function AthleteListItem({ athlete, onMarkAsPaid, onMarkAsUnpaid, markingPaidId }: AthleteListItemProps) {
  const { t } = useTranslation();

  const canMarkAsPaid =
    athlete.lastPurchaseId &&
    athlete.lastPurchaseType === 'offline' &&
    ['pending', 'past_due'].includes(athlete.lastPurchaseStatus);

  const canMarkAsUnpaid =
    athlete.lastPurchaseId &&
    athlete.lastPurchaseType === 'offline' &&
    athlete.lastPurchaseStatus === 'paid';

  return (
    <div className={styles.athlete_list_item}>
      <div className={styles.name_container}>
        <div className={styles.avatar}>
          <UserAvatar
              srcName={athlete.profilePicture}
              userName={athlete.firstName + " " + athlete.lastName}
              altName="avatar"
              className={styles.avatar}
              sizeHeight={40}
              sizeWidth={40}
            />
        </div>
        <div>{athlete.firstName} {athlete.lastName}</div>
      </div>
        <div className={styles.method}>{athlete.paymentMethod || '-'}</div>
        <div className={styles.collection}>{athlete.collectionType || '-'}</div>
        <div className={styles.purchases}>{athlete.purchaseCount}</div>
        <StatusIndicator payment_status={athlete.lastPurchaseStatus}/>
        <div className={styles.actions_column}>
          {(canMarkAsPaid || canMarkAsUnpaid) ? (
            <div className={`${dropdownStyles.actionWrapper} ${markingPaidId === athlete.lastPurchaseId ? dropdownStyles.actionDisabled : ''}`}>
              <PaymentActionsDropdown disabled={markingPaidId === athlete.lastPurchaseId}>
                <div className={dropdownStyles.dropdownContent}>
                  {canMarkAsPaid && (
                    <button
                      onClick={() => onMarkAsPaid(athlete.lastPurchaseId)}
                      className={dropdownStyles.dropdownItem}
                      disabled={markingPaidId === athlete.lastPurchaseId}
                    >
                      <i className="icon-ok" />
                      <span>{t('Mark as Paid')}</span>
                    </button>
                  )}
                  {canMarkAsUnpaid && (
                    <button
                      onClick={() => onMarkAsUnpaid(athlete.lastPurchaseId)}
                      className={dropdownStyles.dropdownItem}
                      disabled={markingPaidId === athlete.lastPurchaseId}
                    >
                      <i className="icon-undo" />
                      <span>{t('Mark as Unpaid')}</span>
                    </button>
                  )}
                </div>
              </PaymentActionsDropdown>
            </div>
          ) : (
            <div className={dropdownStyles.actionMenuDisabled}>
              <i className="bullets" />
            </div>
          )}
        </div>
    </div>
  );
}
